/**
 * @description Authentication Store Module
 * @author Fahid Mohammad
 */


import http from '../../util/axios'
const VueCookie = require('vue-cookie') // using require to avoid SSR rejection

export default {
    namespaced: true,
    state: {
    },
    mutations:{
    },
    actions:{
        DASHBOARD_CONFIRMEDGRAPH({ commit }, form) {
            return http.post("/dashboardV3/confirmedGraph", form).then(response => {
                if(response.status===1000){
                    // console.log("/dashboardV3/confirmedGraph by store action");
                    return response
                }else{
                    return {status:response.status, message:response}
                }
            })
        },
        DASHBOARD_V1({ commit }, form) {
            return http.post("/dashboardV3/v1", form).then(response => {
                if(response.status===1000){
                    // console.log("/dashboardV3/v1 by store action");
                    return response
                }else{
                    return {status:response.status, message:response}
                }
            })
        },
        PRODUCT_LIST( { commit } ) {
            return http.get('/dashboardV3/products').then(response => {
                if(response.status===1000){
                    VueCookie.set("productList",JSON.stringify(response.data));
                    // console.log("/dashboardV3/products by store action");
                    return response
                }else{
                    return {status:response.status, message:response}
                }
            })
        }
    },
    getters:{
    }
}




// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js